


























import Component from 'vue-class-component'
import Vue from 'vue'
import DeliveriesTable from '@/components/deliveries/DeliveriesTable.vue'
import shipmentStore from '@/stores/ShipmentStore'
import deliveryStore from '@/stores/DeliveryStore'
import { Prop, Watch } from 'vue-property-decorator'
import { Routes } from '@/router/routes'

@Component({
  components: { DeliveriesTable },
})
export default class Deliveries extends Vue {
  @Prop(String)
  deliveryId: string | null

  isPending: boolean = true
  shipmentStore = shipmentStore
  deliveryStore = deliveryStore

  get isFullSplitter() {
    return this.$route.name === Routes.deliveries
  }

  @Watch('deliveryId', { immediate: true })
  onChangeRoute(deliveryId: string | null) {
    this.deliveryStore.selectDelivery(deliveryId ? parseInt(deliveryId) : null)
  }

  @Watch('shipmentStore.shipmentPointId', { immediate: true })
  loadDeliveries(shipmentPointId: string | null) {
    this.isPending = true
    this.deliveryStore
      .loadDeliveries(shipmentPointId)
      .finally(() => (this.isPending = false))
  }
}
